import {
  ApiClient,
  PlanAProvider,
  useAuthentication,
} from '@alexandrainst/plana-react-api'

export const AuthenticatedPlanAProvider = ({
  children,
  client,
}: React.PropsWithChildren<{ client: ApiClient }>) => {
  const {
    state: { token },
  } = useAuthentication()
  return (
    <PlanAProvider client={client.withToken(token)}>{children}</PlanAProvider>
  )
}
